import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './LostProjectsRoom.css';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchQuotationList } from '../redux/quotationReducer';
import { useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { fetchLostProjects } from '../redux/LostReducer';
import { fetchRoomList } from '../redux/viewRoomReducer';

function LostProjectsRoom() {
    const navigation = useNavigate();

    const dispatch = useDispatch();
    const { data, status, error } = useSelector((state) => state.lostProjects); // Fetch state from Redux

    const userUID = localStorage.getItem('userUID');
    console.log("userUID:", userUID);

    const location = useLocation();
    const project = location.state || {}; // Provide a fallback to avoid errors
    console.log("Project Data:", project);

    useEffect(() => {
        const clientUID = project.id;
        // console.log("Fetching quotations for client ID:", clientUID);
        dispatch(fetchLostProjects({ clientUID }));
    }, [dispatch, project.id]);

    useEffect(() => {
        const viewData = {
            Id: project.id,
        };
        dispatch(fetchRoomList(viewData));
        // const clientUID = dataOfClient.id;
        // console.log("checking ID", clientUID);
        // dispatch(fetchQuotationList({ clientUID, page: currentPage, lim }));
    },
        []);



    const { viewData, viewLoader, viewError } = useSelector((state) => state.viewrooms);
    console.log('all data', viewData);

    const result = Array.isArray(viewData) ? viewData.reduce((finalArray, current) => {
        console.log('viewData f', finalArray);
        console.log('viewData c', current);

        let obj = finalArray.find(item => item.roomTypeName === current.roomTypeName);
        console.log('obj', obj);
        if (obj) {
            return finalArray;
        }
        return finalArray.concat([current]);
    }, []) : [];

    // useEffect(() => {
    //     if (result.length > 0) {
    //         setroomTypeName(result[0].roomTypeName);
    //     }
    // }, [result]); // Update if result changes

    useEffect(() => {
        if (result.length > 0) {
            setRoomName(result[0].roomType);
        }
    }, [dispatch]); // Update if result changes
    const [roomName, setRoomName] = useState(result[0]?.roomType || "");
    const [roomTypeName, setroomTypeName] = useState(result.length > 0 ? result[0].roomTypeName : "");
    console.log('roomName', roomName)
    console.log('roomTypeName', roomTypeName)
    const [drowOpen, setDrowOpen] = useState(false);

    const viewDesign = (i) => {
        // dataOfClient['roomType'] = i.roomType;
        project['viewData'] = i;
        navigation('/projects/view-rooms/view-designs', { state: project })
    }



    return (
        <Container fluid>
            <Row>
                <Col sm={1}></Col>
                <Col sm={11}></Col>
            </Row>
            <Row>
                <Col sm={1}></Col>
                <Col sm={11}>
                    <div className="lost1">
                        <div>
                            <h5>LOST PROJECTS</h5>
                        </div>
                    </div>
                    <hr />
                </Col>
            </Row>

            <Row>
                <Col sm={1}></Col>
                <Col sm={11}>
                    <div>
                        <div className="sliderBody">
                            <div className="sliderBody2">
                                <p>List of projects that have been lost</p>
                            </div>
                            <hr />
                            <div className="roomcontainer" >
                                {result.length > 0 ? (
                                    result.map((i, ind) => (
                                        <div
                                            key={ind}
                                            onClick={() => setRoomName(i.roomType)}
                                            className={`roomcontainer2 ${roomName === i.roomType ? "selected-room" : ""}`}
                                        >
                                            {i.roomTypeName}
                                        </div>
                                    ))
                                ) : (
                                    <p className="alert">No rooms available</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div>
                            <h6>Design options for {roomName}  </h6>
                            <div className='containerbox' >
                                {viewData.length > 0 && viewData.some(i => i.roomType === roomName) ? (
                                    viewData
                                        .filter(i => i.roomType === roomName) // Filter by selected room
                                        .map((i, ind) => (
                                            <div key={ind}>
                                                <div className="containerbox1">
                                                    <div className="containerbox2" >
                                                        <p>{i.roomTypeDesign}</p> {/* Changed <h> to <h4> (semantic) */}

                                                        <Dropdown>
                                                            <Dropdown.Toggle as="div"  >
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={() => viewDesign(i)}>View</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <p>₹ {i.roomTypePrice}</p> {/* Changed <h> to <h4> (semantic) */}
                                                </div>
                                            </div>
                                        ))
                                ) : (
                                    <p className="alert">No rooms available</p>
                                )}

                            </div>
                        </div>

                    </div>

                </Col>
            </Row>
        </Container>
    );
}

export default LostProjectsRoom;
